
export const _en = {
    title: { label: "NEOPLAN" },
    idInput: { placeholder: "Login" },
    pwdInput: { placeholder: "Password" },
    submitBtn: { label: "Log in" }
};

export const _fr = {
    title: { label: "NEOPLAN" },
    idInput: { placeholder: "Identifiant" },
    pwdInput: { placeholder: "Mot de passe" },
    submitBtn: { label: "Se connecter" }
};